import { render } from "./FashionAndroid.vue?vue&type=template&id=1b1bd8a7&scoped=true"
import script from "./FashionAndroid.vue?vue&type=script&lang=js"
export * from "./FashionAndroid.vue?vue&type=script&lang=js"

import "./FashionAndroid.vue?vue&type=style&index=0&id=1b1bd8a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1bd8a7"]])

export default __exports__